import { PROPOSAL_ACCENT, PROPOSAL_COPY_FONT, PROPOSAL_TEXT } from "@/lib/proposalTheme";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type Props = {
  eyebrow: string;
  title: string;
  children: ReactNode;
  className?: string;
  variant?: "elevated" | "muted";
};

/** Shared section card — matches projector / D-Tools premium proposal sections. */
export default function ProposalSectionCard({
  eyebrow,
  title,
  children,
  className,
  variant = "muted",
}: Props) {
  return (
    <div
      className={cn(
        "rounded-xl border border-[#1A2744]/10 p-5 sm:p-6",
        variant === "elevated" ? "bg-white" : "bg-[#FAFAF7]/80",
        className,
      )}
      style={{ fontFamily: PROPOSAL_COPY_FONT }}
    >
      <p className="text-xs font-medium uppercase tracking-[0.16em]" style={{ color: PROPOSAL_ACCENT }}>
        {eyebrow}
      </p>
      <h2 className="mt-2 text-base font-semibold tracking-tight sm:text-lg" style={{ color: PROPOSAL_TEXT }}>
        {title}
      </h2>
      <div className="mt-3 text-sm leading-7 text-[#1A2744]/90">{children}</div>
    </div>
  );
}
